__turbopack_context__.v({
  "contacts": "qweA8W_contacts",
  "contacts__contact-block": "qweA8W_contacts__contact-block",
  "contacts__contact-data": "qweA8W_contacts__contact-data",
  "contacts__region-title": "qweA8W_contacts__region-title",
});
